export const careersListings: CareerListItem[] = [];
